import colors from '../../../../config/shared/theming/colors';

export const colorsPalette = {
  ...colors,
  // Green
  green600: '#52C41A',
  green500: '#769E1E',
  green400: '#8cbb23',
  green300: '#95c441',
  green250: '#c9e292',
  green100: '#f6ffed',
  green800: '#4E6C0C',
  lime800: '#5B8C00',

  //Black - white
  gray100: '#b8b8b8',
  gray150: '#BFBFBF',
  gray200: '#a8a8a8',
  gray250: '#C8C8C8',
  gray300: '#808080',
  gray400: '#8C8C8C',
  gray450: '#697177',
  grayOpacity5: 'rgba(0,0,0,0.05)',
  grayOpacity6: 'rgba(0,0,0,0.06)',
  grayOpacity8: 'rgba(0,0,0,0.08)',
  grayOpacity12: 'rgba(0,0,0,0.12)',
  grayOpacity25: 'rgba(0,0,0,0.25)',
  grayOpacity45: 'rgba(0,0,0,0.45)',
  grayOpacity65: 'rgba(0,0,0,0.65)',
  grayOpacity88: 'rgba(0,0,0,0.88)',
  gray600: '#404040',
  gray700: '#333333',
  lightGray300: '#e5e5e5',
  lightGray350: '#E8E8E8',
  lightGray280: '#F0F0F0',
  lightGray250: '#F8F9FA',
  lightGray200: '#F9FAFB',
  lightGray100: '#f7f7f7',
  lightGray150: '#f5f5f5',
  lightGray400: '#dbdbdb',
  lightGray450: '#D7DBDF',
  lightGray700: '#889096',
  white: '#ffffff',
  whiteOpacity70: 'rgba(255,255,255,0.7)',
  black: '#000',

  //Yellow
  yellow650: '#FC3',
  yellow600: '#FFCC66',
  yellow300: '#FFEEBC',
  yellow100: '#FFFBEF',
  yellow800: '#765C0D',

  //Blue
  dustyBlue200: '#C0D8E0',
  dustyBlue300: '#6db9d4',
  dustyBlue500: '#2BA6CB',
  dustyBlue600: '#007FA5',
  dustyBlue700: '#1677FF',
  dustyBlue900: '#233862',
  lightBlue200: '#C8EEFF',
  lightBlue100: '#EAF7FF',
  lightBlue50: 'rgba(240, 254, 255, 1)',
  lightIconBlue100: 'rgba(43, 166, 203, 1)',

  teal500: '#13C2C2',
  teal600: '#0EA8A8',

  // Red
  red50: '#FFEEE6',
  red100: '#ff7875',
  red200: '#FFA98C',
  red250: '#FFCCC7',
  red800: '#A8071A',
  red500: '#E53110',
  red300: '#FF6633',
  red600: '#FF4D4F',
  red650: '#BF1A04',
  red900: '#971C19',
  dustyRed600: '#B6211E',
  dustyRed500: '#CA2521',
  dustyRed300: '#E49290',
  dustyRed100: '#FFF3F0',

  // Orange
  orange600: '#FA8C16',
  orange800: '#AD4E00',
  gold800: '#876800',

  violet100: '#f9f0ff',
  violet500: '#9254de',
  violet600: '#722ed1',

  pink: {
    background: '#FFF0F6',
    border: '#FFADD2',
    text: '#EB2F96',
  },

  // beeline. Yellow - black - gray
  beelineYellow500: '#FFC800',
  beelineYellow400: '#FDC435',
  beelineYellow300: '#FFE632',
  beelineBlack600: '#141414',
  beelineYellowOpacity: 'rgba(255, 200, 0, 0.48)',
  beelineBlack500: '#000000de',
  beelineBlack500Opacity: 'rgba(0, 0, 0, 0.48)',
  beelineBlack400: '#090b16f0',
  beelineGray500: '#090b16f0',
  beelineDarkGray400: '#191c342e',
  beelineGray300: '#191c3414',
};
